import changeBeelineToken from './contents/changeBeelineToken.ts';
import changeDocsDeniedCauseCorpVerify from './contents/changeDocsDeniedCauseCorpVerify.ts';
import changeExecutorDeniedCauseCorpVerify from './contents/changeExecutorDeniedCauseCorpVerify.ts';
import changeExecutorDeniedCauseInvite from './contents/changeExecutorDeniedCauseInvite.ts';
import changeExecutorOrg from './contents/changeExecutorOrg.ts';
import changeExecutorOrgDeniedCausePays from './contents/changeExecutorOrgDeniedCausePays.ts';
import changeExecutorOrgDeniedCauseTax from './contents/changeExecutorOrgDeniedCauseTax.ts';
import changePassportDeniedCauseCorpVerify from './contents/changePassportDeniedCauseCorpVerify.ts';
import chatExecutorDocExists from './contents/chatExecutorDocExists.ts';
import chatResponsible from './contents/chatResponsible.ts';
import chatSupportMessage from './contents/chatSupportMessage.ts';
import checkCalcPayAmount from './contents/checkCalcPayAmount.ts';
import contractAlreadyCreate from './contents/contractAlreadyCreate.ts';
import contractHasMvd from './contents/contractHasMvd.ts';
import dealStepSupport from './contents/dealStepSupport.ts';
import deleteArticle from './contents/deleteArticle.ts';
import deleteBeelineUser from './contents/deleteBeelineUser.ts';
import deleteChat from './contents/deleteChat.ts';
import deleteChatMailing from './contents/deleteChatMailing.ts';
import deleteChatTemplate from './contents/deleteChatTemplate.ts';
import deleteCity from './contents/deleteCity.ts';
import deleteDeal from './contents/deleteDeal.ts';
import deleteDealDenied from './contents/deleteDealDenied.ts';
import deleteDealGroup from './contents/deleteDealGroup.ts';
import deleteDealGroupDenied from './contents/deleteDealGroupDenied.ts';
import deleteDealStep from './contents/deleteDealStep.tsx';
import deleteDragDeal from './contents/deleteDragDeal.tsx';
import deleteExecutor from './contents/deleteExecutor.ts';
import deleteExecutorDenied from './contents/deleteExecutorDenied.ts';
import deleteExecutorType from './contents/deleteExecutorType.ts';
import deleteExecutorTypeDenied from './contents/deleteExecutorTypeDenied.ts';
import deleteIntegration from './contents/deleteIntegration.ts';
import deleteJoin from './contents/deleteJoin.ts';
import deleteJoinDoc from './contents/deleteJoinDoc.ts';
import deleteJoinDocDenied from './contents/deleteJoinDocDenied.ts';
import deleteJoinScript from './contents/deleteJoinScript.ts';
import deleteJoinScriptDenied from './contents/deleteJoinScriptDenied.ts';
import deleteKuperShiftGroup from './contents/deleteKuperShiftGroup.ts';
import deleteKuperShiftGroupDenied from './contents/deleteKuperShiftGroupDenied.ts';
import deleteKuperShifts from './contents/deleteKuperShifts.ts';
import deletePayGroup from './contents/deletePayGroup.ts';
import deletePayGroupDenied from './contents/deletePayGroupDenied.ts';
import deletePayProject from './contents/deletePayProject.ts';
import deletePayProjectDenied from './contents/deletePayProjectDenied.ts';
import deletePays from './contents/deletePays.ts';
import deleteReferral from './contents/deleteReferral.ts';
import deleteReferralDenied from './contents/deleteReferralDenied.ts';
import deleteTag from './contents/deleteTag.ts';
import deleteTask from './contents/deleteTask.ts';
import deleteTaskDenied from './contents/deleteTaskDenied.ts';
import deleteUser from './contents/deleteUser.ts';
import deleteWallet from './contents/deleteWallet.ts';
import deletetCountry from './contents/deletetCountry.ts';
import executorActive from './contents/executorActive.tsx';
import inactiveJoinContract from './contents/inactiveJoinContract.ts';
import inactiveJoinContractHasMvd from './contents/inactiveJoinContractHasMvd.ts';
import infoChangeSuccessStepDealWithJoin from './contents/infoChangeSuccessStepDealWithJoin.ts';
import inviteExecutor from './contents/inviteExecutor.ts';
import inviteUser from './contents/inviteUser.ts';
import listDealGroup from './contents/listDealGroup.tsx';
import newVersion from './contents/newVersion.ts';
import notChangeStepDealCauseJoin from './contents/notChangeStepDealCauseJoin.ts';
import parseAct from './contents/parseAct.tsx';
import pinChat from './contents/pinChat.ts';
import pressShiftDeleteDragDeal from './contents/pressShiftDeleteDragDeal.ts';
import rejectTask from './contents/rejectTask.ts';
import rejectVerification from './contents/rejectVerification.tsx';
import removeTax from './contents/removeTax.ts';
import roleUsersHasProxies from './contents/roleUsersHasProxies.ts';
import serverNotAvailable from './contents/serverNotAvailable.ts';
import setCardNumberFromChat from './contents/setCardNumberFromChat.ts';
import setRejectDealStep from './contents/setRejectDealStep.tsx';
import setSuccessDealStep from './contents/setSuccessDealStep.tsx';
import stopPays from './contents/stopPays.ts';
import stopPaysEmpty from './contents/stopPaysEmpty.ts';
import userRemoveProxy from './contents/userRemoveProxy.ts';
import verification from './contents/verification.ts';
import withdrawTax from './contents/withdrawTax.ts';

const contents = {
    deleteJoin,
    deleteUser,
    deletePays,
    deletePayGroupDenied,
    deletePayGroup,
    inactiveJoinContractHasMvd,
    inactiveJoinContract,
    removeTax,
    withdrawTax,
    parseAct,
    deleteTag,
    contractAlreadyCreate,
    contractHasMvd,
    deletePayProjectDenied,
    deletePayProject,
    checkCalcPayAmount,
    inviteUser,
    userRemoveProxy,
    changePassportDeniedCauseCorpVerify,
    rejectVerification,
    changeDocsDeniedCauseCorpVerify,
    roleUsersHasProxies,
    deletetCountry,
    deleteCity,
    deleteJoinDoc,
    deleteJoinDocDenied,
    deleteExecutorType,
    deleteExecutorTypeDenied,
    deleteJoinScript,
    deleteJoinScriptDenied,
    changeExecutorDeniedCauseCorpVerify,
    changeExecutorOrgDeniedCausePays,
    changeExecutorOrg,
    deleteWallet,
    executorActive,
    inviteExecutor,
    changeExecutorDeniedCauseInvite,
    deleteExecutor,
    deleteExecutorDenied,
    changeExecutorOrgDeniedCauseTax,
    stopPays,
    stopPaysEmpty,
    chatSupportMessage,
    chatResponsible,
    setCardNumberFromChat,
    deleteChatMailing,
    verification,
    serverNotAvailable,
    newVersion,
    chatExecutorDocExists,
    deleteIntegration,
    deleteBeelineUser,
    changeBeelineToken,
    dealStepSupport,
    deleteDealGroup,
    deleteDealGroupDenied,
    deleteTask,
    deleteTaskDenied,
    deleteArticle,
    setRejectDealStep,
    listDealGroup,
    deleteDealStep,
    deleteDeal,
    deleteDealDenied,
    pressShiftDeleteDragDeal,
    deleteDragDeal,
    pinChat,
    deleteChat,
    setSuccessDealStep,
    notChangeStepDealCauseJoin,
    infoChangeSuccessStepDealWithJoin,
    rejectTask,
    deleteChatTemplate,
    deleteKuperShifts,
    deleteKuperShiftGroup,
    deleteKuperShiftGroupDenied,
    deleteReferral,
    deleteReferralDenied,
} as const;

export default contents;
